export default __webpack_public_path__ + "static/media/gridImage11.a7084228.png";